import { useCallback, useState } from 'react';

import axiosEvaluation from 'config/axiosEvaluation';
import axiosPrivate from 'config/axiosPrivate';

import { animationUrl } from 'config/endpoints';
import { useDispatch } from 'react-redux';
import { updateForm, updateTextForm } from 'store/Client/ClientAnalyser';
import { updateTextOfTextList } from 'store/Client/OrderDisplay';
import { removeStrongTags } from 'utils/StringUtils';

export const useClientTextValidation = ({
  t,
  orderId,
  writerCommandId,
  setErrorSuccessMsg,
  setErrorSuccessImg,
  setErrorSuccess,
  setIsSave,
  textId,
  setConfirmation,
  setIsSuccess,
  actualHtmlContent,
  actualTextContent,
}) => {
  const [isAllValidated, setIsAllValidated] = useState(false);
  const [isPartValidated, setIsPartValidated] = useState(false);
  const [userName, setUserName] = useState('mimi');
  const [nbParts, setNbParts] = useState(0);
  const [nbValidatedParts, setNbValidatedParts] = useState(0);

  const dispatch = useDispatch();

  const checkAllValidated = useCallback(async () => {
    try {
      const [res, resPart] = await Promise.all([
        axiosEvaluation.get(`/client/allValidatedTexts?command=${orderId}`),
        axiosEvaluation.get(
          `/client/partValidatedTexts?writer command=${writerCommandId}`
        ),
      ]);

      setIsAllValidated(res.data.validated);
      setIsPartValidated(resPart.data.validated);

      if (res.data.validated === true) {
        setErrorSuccessMsg(
          `${t('Le dernier texte a été validé avec succès')}!`
        );
        setErrorSuccessImg(animationUrl + '/07_Commande_validée.gif');
      }

      if (resPart.data.userName != null) {
        setUserName(resPart.data.userName);
      }

      setNbParts(res.data.numberOfParts);
      setNbValidatedParts(res.data.numberOfValidatedParts);

      if (resPart.data.validated === true && res.data.validated === false) {
        setErrorSuccessMsg(`${t('')}`);
      }

      setErrorSuccess(true);
    } catch (error) {
      console.log(error);
    }
  }, [orderId, t, writerCommandId]);

  const validateText = async () => {
    setIsSave(false);

    const content = actualHtmlContent || actualTextContent;
    const cleanedHtml = removeStrongTags(content);

    const data = {
      actualHtmlContent: cleanedHtml,
      actualTextContent,
    };

    try {
      const res = await axiosPrivate.put(`/texts/${textId}/validate`, data);

      setConfirmation(false);
      dispatch(updateForm(res.data));
      dispatch(updateTextForm({ key: 'validated', value: true }));
      dispatch(
        updateTextOfTextList({
          id: textId,
          key: 'validated',
          value: true,
        })
      );
      setErrorSuccessMsg(`${t('Le texte a été validé avec succès')}!`);
      setErrorSuccessImg(animationUrl + '/04_Contenu_validé.gif');

      await checkAllValidated();

      setIsSuccess(true);
    } catch (e) {
      setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));

      setIsSuccess(false);
      setErrorSuccess(true);
    }
  };

  return {
    isAllValidated,
    isPartValidated,
    userName,
    nbParts,
    nbValidatedParts,
    validateText,
  };
};
